import { call, fork, put, takeEvery } from 'redux-saga/effects';
import { v4 as uuidv4 } from 'uuid';
import { notificationInit } from '../../modules/notifications/actions';
import { getThermoboxesReportsRequest, getThermoboxesRequest, getModesDictionaryRequest } from '../../api/requests';
import { REQUEST_ERROR_MESSAGE } from './constants';
import { DISMISS_TIME } from '../../api/constants';
import {
	GET_THERMOBOXES_REPORTS,
	setThermoboxesReportsAction,
	setIsThermoboxesReportsLoadingAction,
	setPaginationAction,
	setIsThermoboxesLoadingAction,
	setThermoboxesAction,
	setIsModesLoadingAction,
	setModesAction,
	GET_THERMOBOXES,
	GET_MODES,
} from './actions';
import { errorHandler } from '../../api/utils';

export function* getThermoboxesReportsSaga({ payload: { searchQuery, noLoading } }) {
	try {
		if (!noLoading) {
			yield put(setIsThermoboxesReportsLoadingAction(true));
		}
		const { data, meta, message, toast } = yield call(getThermoboxesReportsRequest, searchQuery);

		if (data) {
			if (toast) {
				yield put(notificationInit({ id: uuidv4(), dismissAfter: DISMISS_TIME, ...toast }));
			}

			yield put(
				setThermoboxesReportsAction(
					data?.map(thermobox => ({
						...thermobox,
						link: `?${searchQuery ? `${searchQuery}&` : ''}modal=thermobox_report&id=${thermobox.id}`,
					})),
				),
			);

			if (meta) {
				yield put(
					setPaginationAction({
						current_page: meta.current_page,
						per_page: meta.per_page,
						from: meta.from,
						last_page: meta.last_page,
						total: meta.total,
					}),
				);
			}
		} else {
			throw new Error(message || REQUEST_ERROR_MESSAGE);
		}
	} catch (error) {
		yield fork(errorHandler, error);
	} finally {
		yield put(setIsThermoboxesReportsLoadingAction(false));
	}
}

export function* getThermoboxesSaga() {
	try {
		yield put(setIsThermoboxesLoadingAction(true));

		const { data, message, toast } = yield call(getThermoboxesRequest, '?receive=all');

		if (data) {
			if (toast) {
				yield put(notificationInit({ id: uuidv4(), dismissAfter: DISMISS_TIME, ...toast }));
			}

			yield put(setThermoboxesAction(data));
		} else {
			throw new Error(message || REQUEST_ERROR_MESSAGE);
		}
	} catch (error) {
		yield fork(errorHandler, error);
	} finally {
		yield put(setIsThermoboxesLoadingAction(false));
	}
}

export function* getModesSaga() {
	try {
		yield put(setIsModesLoadingAction(true));

		const { data, message, toast } = yield call(getModesDictionaryRequest, '?receive=all');

		if (data) {
			if (toast) {
				yield put(notificationInit({ id: uuidv4(), dismissAfter: DISMISS_TIME, ...toast }));
			}

			yield put(setModesAction(data));
		} else {
			throw new Error(message || REQUEST_ERROR_MESSAGE);
		}
	} catch (error) {
		yield fork(errorHandler, error);
	} finally {
		yield put(setIsModesLoadingAction(false));
	}
}

export default function* thermoboxesReportsContainerSaga() {
	yield takeEvery(GET_THERMOBOXES_REPORTS, getThermoboxesReportsSaga);
	yield takeEvery(GET_THERMOBOXES, getThermoboxesSaga);
	yield takeEvery(GET_MODES, getModesSaga);
}
